import React from "react";
import { connect } from "react-redux";
import { LuckyDrawHistoryContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import { REWARD_LUCKY_DRAW_RENDER_TYPE } from "utils/functions/reward";
import { LUCKY_DRAW_SERVICE_RENDER_TYPE } from "utils/functions/luckDraw";
import moment from "moment";
import momentTZ from "moment-timezone";
import * as XLSX from "xlsx";
import queryString from "query-string";
import { RENDER_CHARACTER_REPLACE_BY_PERMISSION } from "utils/functions/string";
import { Inputs, Displays, Tables } from "components";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";

class LuckyDrawHistoryContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
  };

  componentDidMount() {
    const { perPage } = this.state;
    scrollToTopPageFN();
    const query = this.props.router.location.search || `?limit=${perPage}`;
    this.setState(PARSE_LIST_QUERY(this.props.router.location.search, perPage));
    this.fetchData(query);
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_LUCKY_DRAW_HISTORY_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
          total: res.data.totalDocs,
          per_page: res.data.limit,
        },
      });
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    this.setState({
      filterQuery: e,
    });
    this.handleJoinQuery(e, perPage, 1);
  };

  handleClickDetail = (e) => {};

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}`
      : `?limit=${per_page}&page=${page}`;
    this.setState({
      isLoading: true,
    });
    this.props.router.navigate(`${ROUTE_PATH.LUCKY_DRAW_HISTORY}${joinQuery}`);
    this.fetchData(joinQuery);
  };

  handleExport = async (permission) => {
    const { filterQuery } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let joinQuery = filterQuery
      ? `${filterQuery}&pagination=false`
      : `?pagination=false`;
    let res = await portalService.GET_LUCKY_DRAW_HISTORY_LIST(joinQuery);
    if (res && res.status === 200) {
      let wb = XLSX.utils.book_new();
      let ws_name = "SheetJS";

      let ws_data = res.data.docs.reduce((result, e, i) => {
        result.push([
          i + 1,
          momentTZ(e.created_at).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm"),
          e.member_type === "2"
            ? RENDER_CHARACTER_REPLACE_BY_PERMISSION({
                ...permission,
                inputString: e.organization_detail?.name || "",
                action: "export",
              })
            : `${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
                ...permission,
                inputString: e.member_detail?.first_name || "",
                action: "export",
              })} ${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
                ...permission,
                inputString: e.member_detail?.last_name || "",
                action: "export",
              })}`,
          e.luckydraw_reward_name || "",
          LUCKY_DRAW_SERVICE_RENDER_TYPE(e.luckydraw_reward_service_type),
          REWARD_LUCKY_DRAW_RENDER_TYPE(e.luckydraw_reward_type),
        ]);
        return result;
      }, []);

      ws_data.splice(0, 0, [
        "No",
        "Create Date",
        "Customer",
        "Reward",
        "Service Type",
        "Reward Type",
      ]);

      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      let wscols = [
        { wch: 5 },
        { wch: 20 },
        { wch: 30 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
      ];
      ws["!cols"] = wscols;

      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(
        wb,
        `lucky-draw-report-${moment()
          .tz("Asia/Bangkok")
          .format("DD-MM-YYYY_HH-mm")}.xlsx`
      );
      this.setState({
        isBgLoading: false,
      });
    }
  };

  render() {
    const { authenRedux, router } = this.props;
    const { isLoading, isBgLoading, pagination, data } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "lucky_draw");
    return (
      <LuckyDrawHistoryContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <Inputs.InputFilter
          theme_standard_input_filter
          dataFilter={dataFilter(router.location?.search)}
          btnLabel="ค้นหา"
          onQueryFilter={this.handleFilterKeyword}
          onExport={
            permission &&
            (permission.is_export || permission.is_export_condition)
              ? () => this.handleExport(permission)
              : false
          }
        />
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="324px" />
        ) : (
          <>
            <div className="body_table">
              <Tables.Standard
                columns={columns({
                  permission: permission,
                  handleClickDetail: this.handleClickDetail,
                })}
                data={data}
                showPagination
                pagination={pagination}
                handlePageClick={this.handlePageClick}
                onChangePerPage={this.handlePerPageChange}
              />
            </div>
          </>
        )}
      </LuckyDrawHistoryContainerStyled>
    );
  }
}

const dataFilter = (query) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "luckydraw_reward_name",
      length: "311px",
      filter: {
        fieldQuery: "luckydraw_reward_name",
        defaultValue: initialValues["name"],
        type: "text",
        label: "Reward Name search",
        placeholder: "Reward Name",
      },
    },
    {
      accessor: "luckydraw_reward_type",
      length: "311px",
      filter: {
        fieldQuery: "luckydraw_reward_type",
        defaultValue: initialValues["luckydraw_reward_type"],
        type: "dropdown",
        label: "Reward Type",
        placeholder: "",
        options: [
          {
            label: "All",
            value: "",
          },
          {
            label: "E-coupon",
            value: "1",
          },
          {
            label: "Gift",
            value: "2",
          },
        ],
      },
    },
  ];
};

const columns = ({ permission, handleClickDetail }) => [
  {
    Header: <div style={{ textAlign: "left" }}>Create Date</div>,
    accessor: "created_at",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Customer</div>,
    accessor: "member_detail",
    Cell: (props) =>
      props.row.original.member_type === "2" ? (
        RENDER_CHARACTER_REPLACE_BY_PERMISSION({
          ...permission,
          inputString: props.row.original.organization_detail.name,
        })
      ) : (
        <div onClick={() => handleClickDetail(props.row.original._id)}>
          {`${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
            ...permission,
            inputString: props.value?.first_name,
          })} ${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
            ...permission,
            inputString: props.value?.last_name,
          })}`}
        </div>
      ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Reward</div>,
    accessor: "luckydraw_reward_name",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Service Type</div>,
    accessor: "luckydraw_reward_service_type",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {LUCKY_DRAW_SERVICE_RENDER_TYPE(props.value)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Reward Type</div>,
    accessor: "luckydraw_reward_type",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {REWARD_LUCKY_DRAW_RENDER_TYPE(props.value)}
      </div>
    ),
  },
  // {
  //   Header: <div style={{ textAlign: 'left' }}>คะแนนในการแลก</div>,
  //   accessor: 'redeem_point',
  //   Cell: (props) => (
  //     <div onClick={() => handleClickDetail(props.row.original._id)}>
  //       {RenderCommaMoney(props.value, true)}
  //     </div>
  //   ),
  // },
  // {
  //   Header: <div style={{ textAlign: 'left' }}>Action</div>,
  //   accessor: 'action',
  //   Cell: (props) => (
  //     <div onClick={() => handleClickOfflineReward(props.row.original._id)}>
  //       <MdAssignmentAdd size={22} color="#4b1e78" />
  //     </div>
  //   ),
  // },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LuckyDrawHistoryContainer));
